import React, { ReactElement } from "react";
import { PanelMenu } from "primereact/panelmenu";
import { Sidebar } from "primereact/sidebar";
import { AUTH_URL_PROTOCOL } from "../config/auth";
import { IdwalServices } from "../config/services";
import { MenuItem } from "primereact/menuitem";
import { IParentService } from "../types/IParentService";

/**
 * The main sidebar for navigating between top level pages.
 */
export const SideBar = (props: {
    visible: boolean;
    onClose: () => void;
}): ReactElement => {
    const idwalFooterItems = [
        {
            label: "Sign out",
            icon: "pi pi-fw pi-sign-out",
            url: `${AUTH_URL_PROTOCOL}://${process.env.REACT_APP_AUTH_URL}/logout?redirect=${window.location.href}`
        }
    ];

    function icons() {
        return (
            <button
                style={{ position: "absolute", left: "1rem" }}
                className="p-link"
            >
                <img height={30} width={106} src={"https://www.idwalmarine.com/hubfs/Training/images/idwal-logo-reversed.svg"} />
            </button>
        );
    }

    const items = [] as MenuItem[];
    const toolItems = [] as MenuItem[];
    const settingsItems = [] as MenuItem[];

    items.push({
        label: "Dashboard",
        url: "/",
        icon: "pi pi-home"
    });

    items.push({
        label: "Circuit Breakers",
        icon: "pi pi-bolt",
        url: "/circuitbreakers"
    });

    items.push({
        label: "Deployments",
        icon: "pi pi-cloud-upload",
        url: "/deployments"
    });

    settingsItems.push({
        label: "Settings",
        icon: "pi pi-cog",
        url: "",
        items: [{ label: "Configuration", url: "settings/configuration" }]
    });

    const getSubItems = (service: IParentService): MenuItem[] | null => {
        const subItems = [] as MenuItem[];
        service.services.forEach((subService) => {
            subItems.push({
                label: subService.name,
                icon: subService.name,
                url: `service/${service.id}/sub-service/${subService.name}`
            });
        });
        if (subItems.length === 0) {
            return null;
        }
        return subItems;
    };

    IdwalServices.forEach((service) => {
        const subItems = getSubItems(service);
        if (subItems && subItems.length > 0) {
            items.push({
                label: service.name,
                icon: service.icon,
                items: subItems
            });
        } else {
            items.push({
                label: service.name,
                icon: service.icon,
                url: "/service/" + service.id
            });
        }
    });

    return (
        <Sidebar
            visible={props.visible}
            position="right"
            onHide={props.onClose}
            icons={icons()}
        >
            <div className="flex flex-column h-full">
                <p
                    style={{
                        fontStyle: "normal",
                        fontWeight: 400,
                        marginTop: 30,
                        marginBottom: 15,
                        color: "#777777",
                        fontSize: 16
                    }}
                >
                    Developer Dashboard
                </p>

                <PanelMenu
                    model={items}
                    style={{
                        fontStyle: "normal",
                        fontWeight: 400,
                        marginTop: 30,
                        marginBottom: 15,
                        color: "#777777",
                        fontSize: 16
                    }}
                />

                <p
                    style={{
                        fontStyle: "normal",
                        fontWeight: 400,
                        marginTop: 30,
                        marginBottom: 15,
                        color: "#777777",
                        fontSize: 16
                    }}
                >
                    Settings & Tools
                </p>

                <PanelMenu
                    model={settingsItems}
                    style={{
                        fontStyle: "normal",
                        fontWeight: 400,
                        color: "#777777",
                        fontSize: 16
                    }}
                />

                <PanelMenu
                    model={toolItems}
                    style={{
                        fontStyle: "normal",
                        fontWeight: 400,
                        color: "#777777",
                        fontSize: 16
                    }}
                />

                <div className="mt-auto">
                    <hr className="mb-3 border-top-1 border-none border-gray-300"></hr>

                    <PanelMenu
                        model={idwalFooterItems}
                        style={{ width: 288 }}
                    />
                </div>
            </div>
        </Sidebar>
    );
};
